import React from 'react'
import {clearConfirmCloseStepper} from 'redux/actions'
import {connect} from "react-redux";
import Confirm from "../confirm/Confirm";
import ConfirmThreeButtons from "../confirm/ConfirmThreeButtons";
import Tr from "translations/Translations";


function ConfirmCloseStepper(
    {
        confirmCloseStepper,
        clearConfirmCloseStepper
    }) {

    if (!!confirmCloseStepper?.handleSecondConfirm) {
        return (<ConfirmThreeButtons
            onCancel={() => {
                clearConfirmCloseStepper();
            }}
            onConfirm={() => {
                confirmCloseStepper.handleConfirm();
                clearConfirmCloseStepper();
            }}
            onSecondConfirm={() => {
                confirmCloseStepper.handleSecondConfirm();
                clearConfirmCloseStepper();
            }}
            confirmText={Tr('confirm_close_section_name', {name: confirmCloseStepper?.sectionName ? confirmCloseStepper.sectionName : ""})}
            labelSecondConfirm='confirm_close_section_save_autoSave'
            translateConfirmTexts={false}
            open={!!confirmCloseStepper}
        />)
    } else {
        return (<Confirm
            onCancel={() => {
                clearConfirmCloseStepper();
            }}
            onConfirm={() => {
                confirmCloseStepper.handleConfirm();
                clearConfirmCloseStepper();
            }}
            confirmText={Tr('confirm_close_section_name', {name: confirmCloseStepper?.sectionName ? confirmCloseStepper.sectionName : ""})}
            translateConfirmTexts={false}
            open={!!confirmCloseStepper}
        />)
    }
}

export default connect((state) => ({
    confirmCloseStepper: state.store.confirmCloseStepper
}), {
    clearConfirmCloseStepper
})(ConfirmCloseStepper);